import { BookingStates } from '../../../../../constants/booking-states';

export const shouldShowContactInfo = (booking) => {
  const shouldShow = [
    BookingStates.ACTIVE,
    BookingStates.ACCEPTED,
    BookingStates.EXECUTED,
    BookingStates.SETTLED
  ].includes(booking?.obj_state);

  return shouldShow;
};
